import { render, staticRenderFns } from "./MainTopFixManage.vue?vue&type=template&id=7097f036&"
import script from "./MainTopFixManage.vue?vue&type=script&lang=js&"
export * from "./MainTopFixManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7097f036')) {
      api.createRecord('7097f036', component.options)
    } else {
      api.reload('7097f036', component.options)
    }
    module.hot.accept("./MainTopFixManage.vue?vue&type=template&id=7097f036&", function () {
      api.rerender('7097f036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/main-top-fix-manage/MainTopFixManage.vue"
export default component.exports